
import { SolicitacaoTecnicaService } from './../../../../services/solicitacao-tecnica.service';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';

export interface IAprovarModel {
  prazo: Date;
  avaliacao: boolean | number;
}
@Component({
  selector: 'app-modal-avaliar-prorrogacao',
  templateUrl: './osa-execucao-modal-avaliar-prorrogacao.component.html',
  styleUrls: ['./osa-execucao-modal-avaliar-prorrogacao.component.scss']
})
export class OsaExecucaoModalAvaliarProrrogacaoComponent implements OnInit {
  public submitted: boolean = false;
  public model: IAprovarModel = {} as IAprovarModel;
  public solicitacaoId: number;
  public dataHoje: Date = this.truncateDate(new Date());
  public dataLimiteProrrogacao: Date;
  public justificativa: string;

  constructor(
    private dialogRef: MatDialogRef<OsaExecucaoModalAvaliarProrrogacaoComponent>,
    public service: SolicitacaoTecnicaService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.solicitacaoId = data?.solicitacaoId;
    this.dataLimiteProrrogacao = data?.dataLimiteProrrogacao;
    this.justificativa = data?.justificativa;

  }

  public form = new FormGroup({
    prazo: new FormControl("", [Validators.required, this.dateRangeValidator.bind(this)]),
    justificativa: new FormControl(""),
    justificativaAvaliacao: new FormControl("", Validators.required)
  });

  ngOnInit(): void {
    this.model.avaliacao = 1
    this.form.controls['justificativa'].setValue(this.justificativa);
    this.form.controls['prazo'].setValue(new Date(this.data?.data));
    this.controlaAvaliacao();
  }

  public salvar() {

    this.submitted = true;
    if (this.form.invalid) {
      return
    }

    const data = new Date(this.form.get('prazo')?.value);
    const justificativaAvaliacao = this.form.get('justificativaAvaliacao')?.value;

    const dados = {
      avaliacao: this.model?.avaliacao,
      justificativa: justificativaAvaliacao
    } as any;

    if (this.model?.avaliacao === 1)
      dados.data = data;

    this.service.avaliarProrrogacao(this.solicitacaoId, dados).then((res) => {
      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
        this.dialogRef.close();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    }).catch((err) => {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    })
  }

  dateRangeValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) return null;

    const selectedDate = this.truncateDate(new Date(control.value));

    if (selectedDate < this.dataHoje) {
      return { dataMenorHoje: true };
    }

    if (this.dataLimiteProrrogacao && selectedDate > this.dataLimiteProrrogacao) {
      return { dataMaiorLimite: true };
    }

    return null;
  }

  private truncateDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  public controlaAvaliacao() {

    if (this.model.avaliacao === 1) {
      this.form.get('prazo')?.setValidators([Validators.required, this.dateRangeValidator.bind(this)]);

    } else {
      this.form.get('prazo')?.clearValidators();
    }

    this.form.get('prazo')?.updateValueAndValidity();
  }

  public cancelar() {
    this.dialogRef.close();
  }

}
